import { Route } from 'react-router';
import React from 'react';
import routes from '../routes';
import LogoutScreen from '../../screens/Auth/screens/Logout';
import PasswordRecoveryScreen from '../../screens/Auth/screens/PasswordRecovery';
import IntakeParentFormScreen from '../../screens/Intake/screens/IntakeParent';
import IntakeParentFormSuccessScreen from '../../screens/Intake/screens/IntakeParentSuccess';
import RegistrationComplete from '../../screens/Auth/screens/RegistrationComplete';

const authRoutes = [
    <Route exact key={routes.LOGOUT} path={routes.LOGOUT} component={LogoutScreen} />,
    <Route exact key={routes.PASSWORD_RECOVERY} path={routes.PASSWORD_RECOVERY} component={PasswordRecoveryScreen} />,
    <Route exact key={routes.INTAKE_PARENT_FORM} path={routes.INTAKE_PARENT_FORM} component={IntakeParentFormScreen} />,
    <Route exact key={routes.INTAKE_PARENT_FORM_SUCCESS} path={routes.INTAKE_PARENT_FORM_SUCCESS} component={IntakeParentFormSuccessScreen} />,
    <Route
        exact
        key={routes.COMPLETE_REGISTRATION}
        path={routes.COMPLETE_REGISTRATION}
        component={RegistrationComplete}
    />,
];

export default authRoutes;
